const sonarrBlue = '#35c5f4';
const sonarrAlternateBlue = '#2193b5';
const darkGray = '#888';
const mediumGray = '#999';
const gray = '#adadad';
const black = '#000';
const white = '#fff';
const offWhite = '#f5f7fa';
const purple = '#7a43b6';
const pink = '#ff69b4';
const lightGray = '#ddd';
const defaultColor = '#333';

module.exports = {
  textColor: '#515253',
  defaultColor,
  disabledColor: '#999',
  dimColor: '#555',
  black,
  white,
  offWhite,
  primaryColor: '#5d9cec',
  selectedColor: '#f9be03',
  successColor: '#27c24c',
  dangerColor: '#f05050',
  warningColor: '#ffa500',
  infoColor: sonarrBlue,
  purple,
  pink,
  sonarrBlue,
  helpTextColor: '#909293',
  darkGray,
  gray,
  lightGray,
  mediumGray,

  // Theme Colors

  themeBlue: sonarrBlue,
  themeAlternateBlue: sonarrAlternateBlue,
  themeRed: '#c4273c',
  themeDarkColor: '#3a3f51',
  themeLightColor: '#4f566f',
  pageBackground: '#f5f7fa',
  pageFooterBackground: '#f1f1f1',

  torrentColor: '#00853d',
  usenetColor: '#17b1d9',

  // Labels
  inverseLabelColor: '#ddd',
  inverseLabelTextColor: defaultColor,
  disabledLabelColor: '#999',
  infoTextColor: white,

  // Links
  defaultLinkHoverColor: '#fff',
  linkColor: '#5d9cec',
  linkHoverColor: '#1b72e2',

  // Header
  pageHeaderBackgroundColor: sonarrAlternateBlue,

  // Sidebar

  sidebarColor: '#e1e2e3',
  sidebarBackgroundColor: '#3a3f51',
  sidebarActiveBackgroundColor: '#252833',

  // Toolbar
  toolbarColor: '#e1e2e3',
  toolbarBackgroundColor: '#4f566f',
  toolbarMenuItemBackgroundColor: '#454b60',
  toolbarMenuItemHoverBackgroundColor: '#3a3f51',
  toolbarLabelColor: '#8895aa',

  // Accents
  borderColor: '#e5e5e5',
  inputBorderColor: '#dde6e9',
  inputBoxShadowColor: 'rgba(0, 0, 0, 0.075)',
  inputFocusBorderColor: '#66afe9',
  inputFocusBoxShadowColor: 'rgba(102, 175, 233, 0.6)',
  inputErrorBorderColor: '#f05050',
  inputErrorBoxShadowColor: 'rgba(240, 80, 80, 0.6)',
  inputWarningBorderColor: '#ffa500',
  inputWarningBoxShadowColor: 'rgba(255, 165, 0, 0.6)',
  colorImpairedGradient: '#ffffff',
  colorImpairedGradientDark: '#f4f5f6',
  colorImpairedDangerGradient: '#d84848',
  colorImpairedWarningGradient: '#e59400',
  colorImpairedPrimaryGradient: '#538cd4',
  colorImpairedGrayGradient: '#9b9b9b  ',

  //
  // Buttons

  defaultButtonTextColor: '#eee',
  defaultBackgroundColor: '#fff',
  defaultBorderColor: '#eaeaea',
  defaultHoverBackgroundColor: '#f5f5f5',
  defaultHoverBorderColor: '#d6d6d6',

  primaryBackgroundColor: '#5d9cec',
  primaryBorderColor: '#5899eb',
  primaryHoverBackgroundColor: '#4b91ea',
  primaryHoverBorderColor: '#3483e7',

  successBackgroundColor: '#27c24c',
  successBorderColor: '#26be4a',
  successHoverBackgroundColor: '#24b145',
  successHoverBorderColor: '#1f9c3d',

  warningBackgroundColor: '#ff902b',
  warningBorderColor: '#ff8d26',
  warningHoverBackgroundColor: '#ff8517',
  warningHoverBorderColor: '#fc7800',

  dangerBackgroundColor: '#f05050',
  dangerBorderColor: '#f04b4b',
  dangerHoverBackgroundColor: '#ee3d3d',
  dangerHoverBorderColor: '#ec2626',

  iconButtonDisabledColor: '#7a7a7a',
  iconButtonHoverColor: '#666',
  iconButtonHoverLightColor: '#ccc',

  //
  // Modal

  modalBackdropBackgroundColor: 'rgba(0, 0, 0, 0.6)',
  modalBackgroundColor: '#fff',
  modalCloseButtonHoverColor: '#888',

  //
  // Menu
  menuItemColor: '#e1e2e3',
  menuItemHoverColor: '#fbfcfc',
  menuItemHoverBackgroundColor: '#f5f7fa',

  //
  // Toolbar

  toobarButtonHoverColor: '#35c5f4',
  toobarButtonSelectedColor: '#35c5f4',

  //
  // Scroller

  scrollbarBackgroundColor: '#9ea4b9',
  scrollbarHoverBackgroundColor: '#656d8c',

  //
  // Card

  cardBackgroundColor: '#fff',
  cardShadowColor: '#e1e1e1',
  cardAlternateBackgroundColor: '#f5f5f5',
  cardCenterBackgroundColor: '#fff',

  //
  // Alert

  alertDangerBorderColor: '#ebccd1',
  alertDangerBackgroundColor: '#f2dede',
  alertDangerColor: '#a94442',

  alertInfoBorderColor: '#bce8f1',
  alertInfoBackgroundColor: '#d9edf7',
  alertInfoColor: '#31708f',

  alertSuccessBorderColor: '#d6e9c6',
  alertSuccessBackgroundColor: '#dff0d8',
  alertSuccessColor: '#3c763d',

  alertWarningBorderColor: '#faebcc',
  alertWarningBackgroundColor: '#fcf8e3',
  alertWarningColor: '#8a6d3b',

  //
  // Slider

  sliderAccentColor: '#5d9cec',

  //
  // Form

  inputBackgroundColor: '#fff',
  inputReadOnlyBackgroundColor: '#eee',
  inputHoverBackgroundColor: '#f8f8f8',
  inputSelectedBackgroundColor: '#e2e2e2',
  advancedFormLabelColor: '#ff902b',
  disabledCheckInputColor: '#ddd',
  disabledInputColor: '#808080',

  //
  // Popover

  popoverTitleBackgroundColor: '#f7f7f7',
  popoverTitleBorderColor: '#ebebeb',
  popoverBodyBackgroundColor: '#e9e9e9',
  popoverShadowColor: 'rgba(0, 0, 0, 0.2)',
  popoverArrowBorderColor: '#fff',

  popoverTitleBackgroundInverseColor: '#3a3f51',
  popoverTitleBorderInverseColor: '#4f566f',
  popoverShadowInverseColor: 'rgba(0, 0, 0, 0.2)',
  popoverArrowBorderInverseColor: 'rgba(58, 63, 81, 0.75)',

  //
  // Calendar

  calendarTodayBackgroundColor: '#c5c5c5',
  calendarBackgroundColor: '#e4eaec',
  calendarBorderColor: '#cecece',
  calendarTextDim: '#666',
  calendarTextDimAlternate: '#242424',

  calendarFullColorFilter: 'brightness(30%)',

  //
  // Table

  tableRowHoverBackgroundColor: '#fafbfc',

  //
  // Series

  addSeriesBackgroundColor: '#ededed',
  seriesBackgroundColor: '#ededed',
  searchIconContainerBackgroundColor: offWhite,
  collapseButtonBackgroundColor: offWhite,

  //
  // Season

  seasonBackgroundColor: white,
  episodesBackgroundColor: offWhite,

  //
  // misc

  progressBarFrontTextColor: white,
  progressBarBackTextColor: darkGray,
  progressBarBackgroundColor: white,
  logEventsBackgroundColor: white
};
